export const footerTranslations = {
  FOOTER_PRIVACY_STATEMENT: 'Privacy Statement',
  FOOTER_TERMS_AND_CONDITIONS: 'Terms & Conditions',

  FOOTER_NAVIGATION_TITLE: 'Navigate to...'
};
